<div class="register-loading-overlay" *ngIf="isLoading || !form">
  <ion-img src="/assets/images/logo_cmillonario.svg"></ion-img>
  <ion-spinner color="primary" name="crescent"></ion-spinner>
  <p *ngIf="isLoading" class="register-loading-text">Creando cuenta, por favor espera</p>
</div>

<ion-header *ngIf="isModal">
  <ion-toolbar>
    <ion-title>Crear Cuenta</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()" [disabled]="isLoading">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-button (click)="goToLogin()" fill="clear">
    <ion-icon color="ligth" size="large" slot="icon-only" name="arrow-back-outline"></ion-icon>
  </ion-button>

  <ng-container *ngIf="form">
    <ion-img class="ion-padding-top" src="/assets/images/logo_cmillonario.svg"></ion-img>

    <div class="ion-margin">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <p>Fecha de nacimiento</p>
        <ion-item class="input" [class.field-error]="hasFieldError('dateOfBirth')" lines="none">
          <ion-input
            labelPlacement="floating"
            formControlName="dateOfBirth"
            type="text"
            placeholder="dd-mm-aaaa"
            maxlength="10"
            inputmode="numeric"
            (ionInput)="formatDate($event)"
          ></ion-input>
        </ion-item>

        <!-- Formato requerido -->
        <ion-text
          color="medium"
          class="date-format-hint"
          *ngIf="!form.get('dateOfBirth')?.value || form.get('dateOfBirth')?.value?.length < 10"
        >
          <small>Formato requerido: DD-MM-AAAA (ejemplo: 15-03-1990)</small>
        </ion-text>

        <!-- Mensajes de error -->
        <ion-text color="danger" *ngIf="!isAdult && form.get('dateOfBirth')?.value && isValidDate">
          Debes ser mayor de 18 años.
        </ion-text>
        <ion-text
          color="danger"
          *ngIf="!isValidDate && form.get('dateOfBirth')?.value && form.get('dateOfBirth')?.value?.length === 10"
        >
          Fecha no válida. Verifica el formato: DD-MM-AAAA
        </ion-text>

        <p>Género</p>
        <ion-item class="input" [class.field-error]="hasFieldError('gender')" lines="none">
          <ion-select placeholder="Selecciona tu género" formControlName="gender" interface="popover">
            <ion-select-option value="Femenino">Femenino</ion-select-option>
            <ion-select-option value="Masculino">Masculino</ion-select-option>
            <ion-select-option value="Otro">Prefiero no especificar</ion-select-option>
          </ion-select>
        </ion-item>

        <ion-list>
          <p>Nombre</p>
          <ion-item class="input" [class.field-error]="hasFieldError('name')" lines="none">
            <ion-input #inputName type="text" placeholder="Nombre" formControlName="name"></ion-input>
          </ion-item>
          <p>Apellido paterno</p>
          <ion-item class="input" [class.field-error]="hasFieldError('lastName')" lines="none">
            <ion-input #inputName type="text" placeholder="Apellido paterno" formControlName="lastName"></ion-input>
          </ion-item>
          <p>Apellido materno</p>
          <ion-item class="input" [class.field-error]="hasFieldError('slastName')" lines="none">
            <ion-input #inputName type="text" placeholder="Apellido materno" formControlName="slastName"></ion-input>
          </ion-item>

          <p>Email</p>
          <ion-item class="input" [class.field-error]="hasFieldError('email')" lines="none">
            <ion-input type="email" placeholder="Email" formControlName="email"></ion-input>
          </ion-item>
          <!-- Advertencia de dominio no válido -->
          <ion-text
            color="warning"
            *ngIf="!isValidEmailDomain && form.get('email')?.value && form.get('email')?.valid"
            class="ion-margin-top"
          >
            <small translate>register.email-domain-warning</small>
          </ion-text>

          <!-- Botón para enviar código de verificación -->
          <ion-button
            *ngIf="form.get('email')?.valid && !verificationCodeSent"
            (click)="sendVerificationCode()"
            [disabled]="isSendingCode || !form.get('email')?.valid"
            class="ion-margin-top"
            color="tertiary"
            expand="block"
            shape="round"
            size="small"
          >
            <ion-spinner *ngIf="isSendingCode" name="crescent" size="small"></ion-spinner>
            <span *ngIf="!isSendingCode">Enviar código de verificación</span>
          </ion-button>

          <!-- Mensaje de código enviado -->
          <ion-text color="success" *ngIf="verificationCodeSent" class="ion-margin-top">
            <small>Código de verificación enviado. Revisa tu correo.</small>
          </ion-text>

          <!-- Contador y botón de reenvío -->
          <div *ngIf="verificationCodeSent" class="ion-margin-top">
            <!-- Contador activo -->
            <ion-text *ngIf="resendCountdown > 0" color="medium" class="ion-text-center" style="display: block">
              <small>Puedes solicitar un nuevo código en {{ getFormattedCountdown() }}</small>
            </ion-text>

            <!-- Botón de reenvío (solo visible cuando el contador llega a 0) -->
            <ion-button
              *ngIf="canResendCode"
              (click)="sendVerificationCode()"
              [disabled]="isSendingCode || !form.get('email')?.valid"
              color="tertiary"
              expand="block"
              shape="round"
              size="small"
            >
              <ion-spinner *ngIf="isSendingCode" name="crescent" size="small"></ion-spinner>
              <span *ngIf="!isSendingCode">Volver a enviar código</span>
            </ion-button>
          </div>

          <!-- Input para código de verificación -->
          <div *ngIf="verificationCodeSent" class="ion-margin-top">
            <p>Código de verificación</p>
            <ion-item class="input" [class.field-error]="hasFieldError('verificationCode')" lines="none">
              <ion-input
                type="text"
                placeholder="Ingresa el código"
                formControlName="verificationCode"
                maxlength="6"
                inputmode="numeric"
                (ionInput)="validateVerificationCode()"
              ></ion-input>
            </ion-item>
            <!-- Mensaje de código incorrecto -->
            <ion-text
              color="danger"
              *ngIf="form.get('verificationCode')?.value && form.get('verificationCode')?.hasError('incorrectCode')"
              class="ion-margin-top"
            >
              <small>Código incorrecto. Por favor verifica e intenta nuevamente.</small>
            </ion-text>
            <!-- Mensaje de código correcto -->
            <ion-text color="success" *ngIf="verificationCodeVerified" class="ion-margin-top">
              <small>✓ Código verificado correctamente</small>
            </ion-text>
          </div>

          <p>Contraseña</p>
          <ion-item class="input" [class.field-error]="hasFieldError('password')" lines="none">
            <ion-input type="password" placeholder="Contraseña" formControlName="password">
              <ion-input-password-toggle slot="end"></ion-input-password-toggle>
            </ion-input>
          </ion-item>

          <!-- Requisitos de contraseña -->
          <div class="password-requirements" *ngIf="form.get('password')?.value">
            <p class="requirements-title">Requisitos de la contraseña:</p>
            <div class="requirement-item">
              <ion-icon
                [name]="passwordRequirements.minLength ? 'checkmark-circle' : 'close-circle'"
                [color]="passwordRequirements.minLength ? 'success' : 'medium'"
              >
              </ion-icon>
              <span [class.requirement-met]="passwordRequirements.minLength"> Mínimo 8 caracteres </span>
            </div>
            <div class="requirement-item">
              <ion-icon
                [name]="passwordRequirements.hasUpperCase ? 'checkmark-circle' : 'close-circle'"
                [color]="passwordRequirements.hasUpperCase ? 'success' : 'medium'"
              >
              </ion-icon>
              <span [class.requirement-met]="passwordRequirements.hasUpperCase"> Al menos una letra mayúscula </span>
            </div>
            <div class="requirement-item">
              <ion-icon
                [name]="passwordRequirements.hasLowerCase ? 'checkmark-circle' : 'close-circle'"
                [color]="passwordRequirements.hasLowerCase ? 'success' : 'medium'"
              >
              </ion-icon>
              <span [class.requirement-met]="passwordRequirements.hasLowerCase"> Al menos una letra minúscula </span>
            </div>
            <div class="requirement-item">
              <ion-icon
                [name]="passwordRequirements.hasNumber ? 'checkmark-circle' : 'close-circle'"
                [color]="passwordRequirements.hasNumber ? 'success' : 'medium'"
              >
              </ion-icon>
              <span [class.requirement-met]="passwordRequirements.hasNumber"> Al menos un número </span>
            </div>
          </div>
        </ion-list>

        <ion-item lines="none" class="show-checkbox" [class.field-error]="hasFieldError('termsAccepted')">
          <ion-label class="ion-text-wrap">
            Confirmo que soy mayor de 18 años y declaro haber leído y aceptado los
            <a (click)="openLegalModal('terms')" translate> términos y condiciones </a>
            de CMillonario así como su
            <a (click)="openLegalModal('privacy')" translate> aviso de privacidad </a>, permitiendo enviarme
            notificaciones que podré desactivar cuando quiera.
          </ion-label>
          <ion-checkbox slot="end" formControlName="termsAccepted"></ion-checkbox>
        </ion-item>

        <!-- Mensaje de campos faltantes -->
        <ion-text
          color="danger"
          *ngIf="showFieldErrors && getMissingFields().length > 0"
          class="ion-margin-top missing-fields-message"
        >
          <p>
            <strong>Faltan los siguientes campos: {{ getMissingFields().join(', ') }}</strong>
          </p>
        </ion-text>

        <ion-button
          [disabled]="form.invalid || isLoading || !isAdult || !verificationCodeVerified"
          class="ion-margin-top"
          type="submit"
          color="secondary"
          expand="block"
          shape="round"
          translate
        >
          Registrarse
        </ion-button>
      </form>

      <ion-row class="footer-legal">
        <ion-col size="12" class="ion-text-center">
          <p class="legal-text">
            www.cmillonario.mx Operada en México por Producciones Móviles S.A. de C.V., titular del permiso
            DGAJS/SCEVF/P-06/2005-TER en unión de Unocapali la Paz Operadora S.A. de C.V. de conformidad con los oficios
            DGJS/1580/2021 y DGJS/DCRCA/2090/2022. Juegos prohibidos para menores de edad, juegue responsablemente, no
            olvide que el principal propósito es la recreación, diversión y esparcimiento.
          </p>
        </ion-col>
      </ion-row>
      <br /><br /><br /><br /><br />
    </div>
  </ng-container>
</ion-content>
